export default "__VITE_ASSET__oKwTiu6C__"